import { defineStore } from 'pinia'
import API from '@/api/apiUrls'
import type { FairleadType } from '@/stores/type/ship.type'
import { useApi } from '@/api/useApi'
import { useBaseStore } from '@haskoning/vue-basestore'

const baseUrl = API.FAIRLEAD.BASE

const api = useApi<FairleadType>()

export const useFairleadStore = defineStore('fairlead', () => {
	const baseStore = useBaseStore<FairleadType>({ service: baseUrl, api })
	const resetAll = () => {
		baseStore.reset()
	}

	return {
		...baseStore,
		resetAll
	}
})
